

export const REPORT_LIST = [
  { key: 1, value: 'Cashflow Simulation', description: 'cs' },
  { key: 2, value: 'CVP', description: 'cvp' },
  { key: 3, value: 'PED', description: 'ped' },
  { key: 4, value: 'Operational Expense', description: 'oe' },
  { key: 5, value: 'Cash Flow Sensitivity', description: 'cfs' },
  { key: 6, value: 'Operational Cost Impact', description: 'oci' },
  { key: 7, value: 'CVP Model', description: 'cvp model' },
  { key: 8, value: 'Order Cancellation', description: 'oc' },
  { key: 9, value: 'Price Elasticity', description: 'pe' },
  { key: 10, value: 'Sales Impact', description: 'si' },
  { key: 11, value: 'Shipments with No Sales', description: 'swns' },
  { key: 12, value: 'Significant Performance', description: 'sp' },
  { key: 13, value: 'Shipment On Store', description: 'sos' },
  { key: 14, value: 'Store Closure', description: 'sc' }
];
